<template>
  <div class="trial__timer">
    <svg-icon name="timer" />
    <span>22 часа 43 минуты</span>
    <Tooltip>
      Таймер показывает остаток времени для прохождения заданий образоватльного дня
    </Tooltip>
  </div>
</template>

<script>
import Tooltip from '@/components/Common/Tooltip'

export default {
  name: 'Timer',
  components: { Tooltip }
}
</script>

<style scoped lang="scss">
.trial__timer {
  display: flex;
  align-items: center;
  color: $luchmara;

  svg {
    width: 32px;
    height: 32px;
    fill: $luchmara;

    @include md-and-down {
      width: 24px;
      height: 24px;
    }
  }

  span {
    font-weight: 500;
    font-size: 24px;
    letter-spacing: 0.2px;
    display: block;
    margin: 0 8px;

    @include md-and-down {
      margin: 0 12px;
      font-size: 20px;
    }
  }
}
</style>
